// extracted by mini-css-extract-plugin
module.exports = {"fs18":"floating-see-demo-module--fs18--1e-CT","fs26":"floating-see-demo-module--fs26--12d4A","container":"floating-see-demo-module--container--3Qh3A"};